import { InfoTooltip } from "./InfoTooltip";

interface EmailInfoTooltipProps {
    overlayText?: string;
}

const EmailInfoTooltip = ({ overlayText }: EmailInfoTooltipProps) => <InfoTooltip text={overlayText} />;

export default EmailInfoTooltip;
